export default __webpack_public_path__ + "static/media/Ramaiah.88243aa4.png";